// extracted by mini-css-extract-plugin
export var compact = "_na-2";
export var phoneFrame = "_na-0";
export var phoneScreen = "_na-1";